document.addEventListener('DOMContentLoaded', () => {

  // -------------------------------------------------------------
  // Helper: Recalculate and update the ATC Button Price
  // -------------------------------------------------------------
  function updateButtonPrice(container) {
    if (!container) return;

    // Find the currently active (visible) charm group
    const activeGroup = container.querySelector('[data-charm-selector]:not(.ff-charm--hidden)');
    const priceDisplay = container.querySelector('.btn__price');
    if (!activeGroup || !priceDisplay) return;

    // Base price in cents (from main variant)
    const basePrice = parseInt(activeGroup.dataset.basePrice || '0', 10);

    // Sum of all selected charms in cents
    const selectedCharms = activeGroup.querySelectorAll('[data-charm-option].ff-is-selected');
    let charmsTotal = 0;
    selectedCharms.forEach((btn) => {
      charmsTotal += parseInt(btn.dataset.charmPrice || '0', 10);
    });

    // Quantity multiplier
    const form = container.querySelector('form') || container.querySelector('[data-product-form]');
    const qtyInput = form?.querySelector('input[name="quantity"]') || container.querySelector('quantity-counter input');
    const quantity = parseInt(qtyInput?.value || '1', 10);
    const validQty = isNaN(quantity) || quantity < 1 ? 1 : quantity;

    // Total price in cents
    const totalCents = (basePrice + charmsTotal) * validQty;

    // Format using Broadcast's built-in money formatter
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      const formattedPrice = window.theme.formatMoney(totalCents, window.theme.moneyFormat);
      priceDisplay.innerHTML = formattedPrice;
    }
  }

  // -------------------------------------------------------------
  // 1. Variant Change Listener
  // -------------------------------------------------------------
  document.addEventListener('theme:variant:change', (e) => {
    const variant = e.detail?.variant;
    if (!variant) return;

    const container = e.target.closest('[data-section-id]') 
      || e.target.closest('.shopify-section') 
      || document;

    const allCharmGroups = container.querySelectorAll('[data-charm-selector]');
    allCharmGroups.forEach((group) => {
      const isMatch = String(group.dataset.parentVariantId) === String(variant.id);
      group.classList.toggle('ff-charm--hidden', !isMatch);

      if (isMatch) {
        // Update stored base price to the newly selected variant's price
        group.dataset.basePrice = variant.price;
      } else {
        // Reset selections on hidden groups
        group.querySelectorAll('[data-charm-option].ff-is-selected').forEach(b => b.classList.remove('ff-is-selected'));
        group.querySelector('[data-charm-none]')?.classList.add('ff-is-selected');
      }
    });

    updateButtonPrice(container);
  });

  // -------------------------------------------------------------
  // 2. Click Handling (Charms, None, Zoom Modal)
  // -------------------------------------------------------------
  document.addEventListener('click', (e) => {
    const charmBtn = e.target.closest('[data-charm-option]');
    const noneBtn = e.target.closest('[data-charm-none]');
    const zoomBtn = e.target.closest('[data-zoom-trigger]');
    const closeBtn = e.target.closest('[data-modal-close]');
    const modal = e.target.closest('[data-charm-modal]') || document.querySelector('[data-charm-modal][open]');

    if (charmBtn && !charmBtn.disabled) {
      charmBtn.classList.toggle('ff-is-selected');
      const group = charmBtn.closest('[data-charm-selector]');
      const none = group?.querySelector('[data-charm-none]');
      if (none) none.classList.remove('ff-is-selected');

      if (group && group.querySelectorAll('[data-charm-option].ff-is-selected').length === 0) {
        none?.classList.add('ff-is-selected');
      }

      const container = charmBtn.closest('[data-section-id]') || charmBtn.closest('.shopify-section') || document;
      updateButtonPrice(container);
    }

    if (noneBtn) {
      const root = noneBtn.closest('[data-charm-selector]');
      root?.querySelectorAll('[data-charm-option].ff-is-selected').forEach(b => b.classList.remove('ff-is-selected'));
      noneBtn.classList.add('ff-is-selected');

      const container = noneBtn.closest('[data-section-id]') || noneBtn.closest('.shopify-section') || document;
      updateButtonPrice(container);
    }

    if (zoomBtn) {
      e.stopPropagation();
      const wrapper = zoomBtn.closest('.ff-bags-cross-sell__option-wrapper');
      const btn = wrapper?.querySelector('[data-charm-option]');
      const m = document.querySelector('[data-charm-modal]');
      if (btn && m) {
        m.querySelector('[data-modal-img]').src = btn.dataset.charmImage || '';
        m.querySelector('[data-modal-title]').textContent = btn.dataset.charmTitle || '';
        m.setAttribute('open', '');
      }
    }

    if (closeBtn || (modal && e.target === modal)) {
      document.querySelector('[data-charm-modal]')?.removeAttribute('open');
    }
  });

  // -------------------------------------------------------------
  // 3. Listen to Quantity Changes (If customer increases bag count)
  // -------------------------------------------------------------
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="quantity"]') || e.target.closest('quantity-counter')) {
      const container = e.target.closest('[data-section-id]') || e.target.closest('.shopify-section') || document;
      updateButtonPrice(container);
    }
  });

  // -------------------------------------------------------------
  // 4. Intercept Broadcast Add to Cart
  // -------------------------------------------------------------
  document.addEventListener('theme:cart:add', async (event) => {
    const atcButton = event.detail?.button;
    if (!atcButton) return;

    const form = atcButton.form || atcButton.closest('form');
    const container = atcButton.closest('[data-section-id]') 
      || atcButton.closest('.shopify-section') 
      || document;

     // 1. Declare the variable outside the block using let (default to null)
    let mainVariantId = null; 

    const activeSwatch = document.querySelector(".custom-variant-swatch.active");

    if (activeSwatch) {
      // 2. Assign the value without using "const" or "let" here
      mainVariantId = activeSwatch.getAttribute("data-variant-id");
      console.log("variantId: ", mainVariantId); 
    }

    if (!mainVariantId || isNaN(parseInt(mainVariantId, 10))) return;

    const root = container.querySelector(`[data-charm-selector][data-parent-variant-id="${mainVariantId}"]`)
      || container.querySelector('[data-charm-selector]:not(.ff-charm--hidden)');

    if (!root) return;

    const selectedCharms = [...root.querySelectorAll('[data-charm-option].ff-is-selected')];
    if (selectedCharms.length === 0) return; // Allow Broadcast to handle normal flow if None selected

    event.stopImmediatePropagation();

    const mainQty = parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10);
    const items = [
      {
        id: parseInt(mainVariantId, 10),
        quantity: isNaN(mainQty) || mainQty < 1 ? 1 : mainQty
      }
    ];

    selectedCharms.forEach((btn) => {
      const charmId = parseInt(btn.dataset.charmVariantId, 10);
      if (!isNaN(charmId)) {
        items.push({
          id: charmId,
          quantity: isNaN(mainQty) || mainQty < 1 ? 1 : mainQty,
          parent_id: parseInt(mainVariantId, 10), // Enables Shopify's native nested child relationship
          properties: {
            _parent_variant_id: mainVariantId,
            "Item Type": "Add-on" // Visible to the customer as "Item Type: Add-on"
            // _item_type: "Add-on" // Use this instead if you want it HIDDEN from the customer
          }
        });
      }
    });


    if (items.length <= 1) return;

    atcButton.classList.add('is-loading');
    atcButton.disabled = true;

    try {
      const cartAddUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      if (window.theme?.settings?.cartType === 'page') {
        window.location = window.theme?.routes?.cart_url || '/cart';
        return;
      }

      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));

    } catch (err) {
      console.error('Cart add error:', err);
      alert(err.message);
    } finally {
      atcButton.classList.remove('is-loading');
      atcButton.disabled = false;
    }
  }, true);

});